/* eslint-disable no-restricted-imports */
import clsx from 'clsx'
import React, {ReactNode, useMemo} from 'react'
import styles from './BarChart.module.scss'

export interface BarChartProps {
    className?: string
    chartData: {
        label: ReactNode | string
        value: number
        barClassName?: string | null
    }[]
    barClassName?: string
}

export const BarChart = ({
    className = '',
    barClassName = '',
    chartData,
}: BarChartProps) => {
    const maxValue = useMemo(() => Math.max(...chartData.map(({value}) => value)), [chartData])
    return (
        <div
            className={clsx(styles.container, className)}
        >
            {
                chartData.map(({label, value, barClassName: itemBarClassName}, idx) => {
                    const barHeight = maxValue ? (value / maxValue) * 100 : 0
                    return (
                        <div className={styles.barContainer} key={idx}>
                            <div className={styles.barWrapper}>
                                <div
                                    className={clsx(styles.bar, barClassName, itemBarClassName)}
                                    style={{height: `${barHeight}%`}} >
                                    {value ? (
                                        <div className={styles.value}>
                                            {value}
                                        </div>
                                    ) : null}
                                </div>
                            </div>
                            <div className={styles.label}>{label}</div>
                        </div>
                    )
                })
            }
        </div>
    )
}
